export const DASHBOARD_GROUP_LINKS = {
  BASE: "/app/dashboard",
};
